import React from 'react';
import ChevronSVG from '../../ChevronSVG';

const DropdownButton = ({ name, callFunction, callVal, chevron, active, expanded, id, isMobile = false, districtInfo = false }) => {

    const disableButton = active === false;

    const newLabel = isMobile && name === 'US' ? 'State' : isMobile && name === 'District' ? name : name;

    return (
		// eslint-disable-next-line react/button-has-type
        <button
            id={id}
            className={`filter-btn${districtInfo ? ' has-district-zoom' : ''}`}
            aria-expanded={expanded}
            onClick={()=>callFunction(callVal)}
            disabled={disableButton}
            data-district-zoom={districtInfo ? districtInfo.zoom : ''}
        >
          {(name !== 'US' && name !== 'District' && isMobile) && (
            <span className="selected-item-checkmark right">
              <div className="icon-checkmark"/>
            </span>
          )}
          <span className="filter-btn-text">{newLabel}</span>
          <ChevronSVG
            chevron={chevron}
            active={active}
          />
        </button>
    );
};

export default DropdownButton;


